export const UPDATE_PROJECT_NAME = 'UPDATE_PROJECT_NAME';
export const UPDATE_RUNTIME_INFO = 'UPDATE_RUNTIME_INFO';
export const UPDATE_FRAMEWORK = 'UPDATE_FRAMEWORK';
export const UPDATE_ENV = 'UPDATE_ENV';
export const UPDATE_PARAMETERS = 'UPDATE_PARAMETERS';
export const UPDATE_MODE = 'UPDATE_MODE';
export const UPDATE_RUNS_ON = 'UPDATE_RUNS_ON';
export const UPDATE_CONCURRENCY = 'UPDATE_CONCURRENCY';
export const UPDATE_FAILURE_COUNT = 'UPDATE_FAILURE_COUNT';
export const TOOGLE_FAILURE = 'TOOGLE_FAILURE';
export const UPDATE_JOB_LABEL = 'UPDATE_JOB_LABEL';
export const UPDATE_TEST_DISCOVERY_RESULT = 'UPDATE_TEST_DISCOVERY_RESULT';
export const GET_USER_YAML = 'GET_USER_YAML';
export const ENABLE_TUNNEL = 'ENABLE_TUNNEL';
export const RESET_HYPEREXECUTE_YAML = 'RESET_HYPEREXECUTE_YAML';
export const UPDATE_HYP_YAML = 'UPDATE_HYP_YAML';
export const REMOVE_HYP_KEY_YAML = 'REMOVE_HYP_KEY_YAML';
export const UPDATE_YAML_COMPOSER = 'UPDATE_YAML_COMPOSER';

export const hyExUpdateYamlComposer = (payload: any) => {
  return {
    type: UPDATE_YAML_COMPOSER,
    payload,
  };
};

export const hyExEnableTunnel = (payload: any) => {
  return {
    type: ENABLE_TUNNEL,
    payload,
  };
};

export const hyExGetUserYaml = (yaml: any) => {
  return {
    type: GET_USER_YAML,
    payload: yaml,
  };
};

export const hyExUpdateTestDiscoveryResult = (payload: any) => {
  return {
    type: UPDATE_TEST_DISCOVERY_RESULT,
    payload,
  };
};

export const hyExUpdateJobLabel = (payload: any) => {
  return {
    type: UPDATE_JOB_LABEL,
    payload,
  };
};

export const hyExToogleFailure = (payload: any) => {
  return {
    type: TOOGLE_FAILURE,
    payload,
  };
};

export const hyExUpdateFailure = (payload: any) => {
  return {
    type: UPDATE_FAILURE_COUNT,
    payload,
  };
};

export const hyExUpdateConcurrency = (payload: any) => {
  return {
    type: UPDATE_CONCURRENCY,
    payload,
  };
};

export const hyExUpdateRunsOn = (payload: any) => {
  return {
    type: UPDATE_RUNS_ON,
    payload,
  };
};

export const hyExUpdateMode = (payload: any) => {
  return {
    type: UPDATE_MODE,
    payload,
  };
};

export function hyExUpdateEnv(payload: any) {
  return {
    type: UPDATE_ENV,
    payload,
  };
}

export function hyExUpdateParameters(payload: any) {
  return {
    type: UPDATE_PARAMETERS,
    payload,
  };
}

export function hyExUpdateProjectName(payload: any) {
  return {
    type: UPDATE_PROJECT_NAME,
    payload,
  };
}

export function hyExUpdateRuntimeInfo(payload: any) {
  return {
    type: UPDATE_RUNTIME_INFO,
    payload,
  };
}

export function hyExUpdateFramework(payload: any) {
  return {
    type: UPDATE_FRAMEWORK,
    payload,
  };
}

export function hyExResetHyperexecuteYaml() {
  return {
    type: RESET_HYPEREXECUTE_YAML,
  };
}

export function hyExUpdateYaml(key: any, payload: any) {
  return {
    type: UPDATE_HYP_YAML,
    payload: {
      key,
      payload,
    },
  };
}

export function hyExRemoveKeyYaml(payload: any) {
  return {
    type: REMOVE_HYP_KEY_YAML,
    payload,
  };
}
